import { InlineNotification } from '@spotnana/blocks/src/InlineNotification';
import { container } from './CheckoutApprovalMessage.styles';

interface IProps {
  showApprovalMessage: boolean;
  message: string;
}

const CheckoutApprovalMessage = ({ showApprovalMessage, message }: IProps): JSX.Element => {
  if (!showApprovalMessage) {
    return <></>;
  }

  return (
    <div css={container}>
      <InlineNotification variant="warning" content={message} />
    </div>
  );
};

export default CheckoutApprovalMessage;
